import { inject, Injectable } from '@angular/core';
import {
  AuthorizationService,
  HttpFilter,
  RestService,
} from '@infodata-group/inf-commons';
import { BehaviorSubject } from 'rxjs';
import { Telework } from './telework';
import { TeleworkFactory } from './telework-factory';

@Injectable({
  providedIn: 'root',
})
export class TeleworkService {
  private readonly rest = inject(RestService);
  private readonly auth = inject(AuthorizationService);

  public loadTeleworks$ = new BehaviorSubject<Telework[]>([]);

  public readonly teleworkColor = this.auth.userContext.teleworkColor;
  public readonly hasTelework = this.auth.userContext.telework;

  public loadTelework(filter: HttpFilter) {
    this.rest.getAll(new TeleworkFactory(), { httpFilter: filter }).subscribe({
      next: (teleworks) => {
        this.loadTeleworks$.next(
          teleworks.reduce((acc, val) => acc.concat(val), []),
        );
      },
      error: (err) => {
        console.error(err);
        this.loadTeleworks$.next([]);
      },
    });
  }
}
